import styled from "styled-components";

export const WidgetCard = styled.div`
    background-color: ${props => (props.backgroundColor ? props.backgroundColor : 'white')};
    border-radius: ${props => (props.borderRadius ? props.borderRadius : '12px')};
    height: ${props => (props.height ? props.height : '-webkit-fill-available')};
    margin: ${props => (props.margin ? props.margin : null)};
    display: ${props => (props.display ? props.display : null)};
    flex-direction: ${props => (props.flexDirection ? props.flexDirection : null)};
    justify-content: ${props => (props.justifyContent ? props.justifyContent : null)};
    padding: ${props => (props.padding ? props.padding : null)};
    font-family: 'Inter';
    width: ${props => (props.width ? props.width : '1fr')};
    max-height: ${props => (props.maxHeight ? props.maxHeight : null)};
    min-height: ${props => (props.minHeight ? props.minHeight : null)};
`;